import { gql } from '@apollo/client';
import { arrayOf, string } from 'prop-types';
import { getProductFragment } from '../product/getProductQuery';

const getPackagesQuery = ({ productDomains }) => {
  const productFragments = getProductFragment({ domains: productDomains });

  let params = [
    '$itemId: String',
    '$limit: Int',
    '$packageId: String',
    '$storeId: String'
  ];

  if (productDomains.includes('keyProductFeatures')) {
    params.push('$maxFeatures: Int');
  }

  const packageQuery = `
    query GetPackages(${params.join(', ')}) {
      packages(itemId: $itemId, limit: $limit, packageId: $packageId, storeId: $storeId) {
        ...BundleMetaSub
        ...BundleProductSub
      }
    }
    fragment BundleMetaSub on PackageBundle {
        metadata {
            packageId
            title
            brandName
            name
            image {
                url
            }
            heroImage {
                url
            }
            brandImage {
                url
            }
            __typename
        }
    }
    ${productFragments.fragments}
    fragment BundleProductSub on PackageBundle {
      products {
        ${productFragments.queryUnwrapped}
      }
    }
`;

  return gql(packageQuery);
};

/*
fragment BundleProductSub on PackageBundle {
      products {

      ...PrimaryIdentifiers
      __typename

      }
    }

 */

getPackagesQuery.propTypes = {
  productDomains: arrayOf(string).isRequired
};
export default getPackagesQuery;
